'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$() {
  this.aQn = null;
  this.aQo = false;
  this.aQh = null;
  this.aQi = false;
  this.aQp = null;
  this.aQq = false;
  this.aQj = null;
  this.aQk = false;
  this.aQl = null;
  this.aQm = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$.prototype = $p;
$p.aA = (function() {
  if ((!this.aQo)) {
    this.aQn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aQo = true;
  }
  return this.aQn;
});
$p.iq = (function() {
  if ((!this.aQi)) {
    this.aQh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aQi = true;
  }
  return this.aQh;
});
$p.ast = (function() {
  if ((!this.aQq)) {
    this.aQp = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$3(this);
    this.aQq = true;
  }
  return this.aQp;
});
$p.af9 = (function() {
  if ((!this.aQk)) {
    this.aQj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Empty$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
      var e$proxy5 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$().iu("");
      if ((e$proxy5 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), (("Expected Right, got Left(" + e$proxy5.bj) + ")"));
      }
      if ((e$proxy5 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        return e$proxy5.aI;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e$proxy5);
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Empty$());
    this.aQk = true;
  }
  return this.aQj;
});
$p.a5o = (function() {
  if ((!this.aQm)) {
    this.aQl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Quantity Type";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aQm = true;
  }
  return this.aQl;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$, "app.data.data_point_types$package$QuantityUnit$", ({
  Gp: 1,
  B: 1,
  C: 1,
  J: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$QuantityUnit$ };
//# sourceMappingURL=app.data.data_point_types$package$-Quantity-Unit$.js.map
